let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kZ6zs")).then(() => parcelRequire('1OjJD'));